import { Attribute, EntityItem } from 'api/ApiTypes'
import { RepeatableAddress } from 'context/ContactContext'
import AttributeUtils from 'utils/AttributeUtils'
import { RepeatablePaymentOption } from 'utils/PaymentUtils'

export const getRelationPayments = (value: any, relations: EntityItem[]) => {
  const payments: any = AttributeUtils.findValueFromRelations(
    value,
    relations
  ) as RepeatablePaymentOption

  if (!payments?.length) {
    return []
  }

  return payments
}

export const getRelationAddress = (value: any, relations: EntityItem[]) => {
  const addresses =
    (AttributeUtils.findValueFromRelations(
      value,
      relations
    ) as RepeatableAddress[]) || []

  if (!addresses?.length) {
    return []
  }

  return addresses
}

export const getRepeatedValue = (attribute: Attribute, value: any[]) => {
  const valueAttributeName =
    attribute.type === 'string' ? 'value' : attribute.type

  if (!value?.length) {
    return []
  }

  return value.map((item) => item[valueAttributeName])
}

export const isEmptyValue = (value: any) =>
  value === undefined || value === null || value === ''
